import { z } from "zod"
import { MessageType } from "../MessageType"

export const SendSmsAsStoreStaffSchema = z.object({
  jobId: z.string().uuid(),
  content: z.string().min(1),
  toPhoneNumber: z.string().min(1),
  customerFirstName: z.string().min(1),
  type: z.nativeEnum(MessageType),
  // The mechanic asked for the message text itself in the SMS rather than the
  // link teaser, accepting that a long message costs several segments. Only a
  // request: the API still delivers the full text regardless when it fits in
  // one segment, since that costs the store nothing extra.
  // multipart/form-data carries booleans as strings.
  sendFullSms: z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .optional(),
  // attachedFiles handled by multer, not in validation
})

export type SendSmsAsStoreStaff = z.infer<typeof SendSmsAsStoreStaffSchema> & {
  attachedFiles?: File[]
}
